const defaultFileUploaded = {
  Mobile: {
    thumbnail: {
      file: null,
      multiPart: null,
      type: "Mobile",
      subType: "thumbnail",
    },
    poster: {
      file: null,
      multiPart: null,
      type: "Mobile",
      subType: "poster",
    },
    coverart: {
      file: null,
      multiPart: null,
      type: "Mobile",
      subType: "coverart",
    },
  },
  Tablet: {
    thumbnail: {
      file: null,
      multiPart: null,
      type: "Tablet",
      subType: "thumbnail",
    },
    poster: {
      file: null,
      multiPart: null,
      type: "Tablet",
      subType: "poster",
    },
    coverart: {
      file: null,
      multiPart: null,
      type: "Tablet",
      subType: "coverart",
    },
  },
  TV: {
    thumbnail: {
      file: null,
      multiPart: null,
      type: "TV",
      subType: "thumbnail",
    },
    poster: { file: null, multiPart: null, type: "TV", subType: "poster" },
    coverart: {
      file: null,
      multiPart: null,
      type: "TV",
      subType: "coverart",
    },
  },
  Web: {
    thumbnail: {
      file: null,
      multiPart: null,
      type: "Web",
      subType: "thumbnail",
    },
    poster: { file: null, multiPart: null, type: "Web", subType: "poster" },
    coverart: {
      file: null,
      multiPart: null,
      type: "Web",
      subType: "coverart",
    },
  },
  Partner: {
    thumbnail: {
      file: null,
      multiPart: null,
      type: "Partner",
      subType: "thumbnail",
    },
    poster: {
      file: null,
      multiPart: null,
      type: "Partner",
      subType: "poster",
    },
    coverart: {
      file: null,
      multiPart: null,
      type: "Partner",
      subType: "coverart",
    },
  },
};
// Default Form Value on Initial Load
const defaultFormValue = {
  channelId: "",
  name: "",
  type: "Linear",
  description: "",
  goLiveDate: new Date(),
  channelTags: [],
  playbackUrl: "",
  territoryDetails: [
    {
      territoryId: "IN",
      territoryName: "India",
    },
  ],
  fillerSourcePath: "",
  regionalLanguage: 2,
  theme: [],
  channelImages: { ...defaultFileUploaded },
  categories: [],
  partners: [],
  channelSetupDate: new Date(),
  channelAssembly: "RUNN_MEDIA",
  isStartOverEnabled: true,
  isWatchListEnabled: true,
  isForceLogin: false,
  forceLoginWatchDuration: "00:05:00",
  epgHandler: "",
  epgType: "",
  playoutBaseUrl: "",
  epgTypeApiUrl: "",
  isKidsSafe: false,
  ratingId: 1,
  applyLogo: false,
  timezones: [
    {
      countryCode: "IN",
      dstOffset: 5.5,
      gmtOffset: 5.5,
      id: 195,
      rawOffset: 5.5,
      timezone: "Asia/Kolkata",
    },
  ],
  scheduleType: "Standard",

  partnerPlaybacks: [
    {
      partnerCode: "",
      partnerName: "",
      contentPlaybackUrl: "",
    },
  ],
};
// Default Error Value on Initial Load
const defaultFormError = {
  name: "",
  partners: "",
  channelId: "",
  type: "",
  channelAssembly: "",
  epgHandler: "",
  epgType: "",
  epgTypeApiUrl: "",
  ratingId: "",
  forceLoginWatchDuration: "",
  timezones: "",
  scheduleType: "",
  territoryDetails: "",
  categories: "",
  channelImages: "",
};

const defaultFiles = {
  Mobile: {
    thumbnail: {
      file: null,
      multiPart: null,
      type: "Mobile",
      subType: "thumbnail",
    },
    poster: { file: null, multiPart: null, type: "Mobile", subType: "poster" },
    coverart: {
      file: null,
      multiPart: null,
      type: "Mobile",
      subType: "coverart",
    },
  },
  Tablet: {
    thumbnail: {
      file: null,
      multiPart: null,
      type: "Tablet",
      subType: "thumbnail",
    },
    poster: { file: null, multiPart: null, type: "Tablet", subType: "poster" },
    coverart: {
      file: null,
      multiPart: null,
      type: "Tablet",
      subType: "coverart",
    },
  },
  TV: {
    thumbnail: {
      file: null,
      multiPart: null,
      type: "TV",
      subType: "thumbnail",
    },
    poster: { file: null, multiPart: null, type: "TV", subType: "poster" },
    coverart: { file: null, multiPart: null, type: "TV", subType: "coverart" },
  },
  Web: {
    thumbnail: {
      file: null,
      multiPart: null,
      type: "Web",
      subType: "thumbnail",
    },
    poster: { file: null, immultiPartg: null, type: "Web", subType: "poster" },
    coverart: {
      file: null,
      immultiPartg: null,
      type: "Web",
      subType: "coverart",
    },
  },
  Partner: {
    thumbnail: {
      file: null,
      multiPart: null,
      type: "Partner",
      subType: "thumbnail",
    },
    poster: {
      file: null,
      immultiPartg: null,
      type: "Partner",
      subType: "poster",
    },
    coverart: {
      file: null,
      immultiPartg: null,
      type: "Partner",
      subType: "coverart",
    },
  },
};
export {
  defaultFileUploaded,
  defaultFormValue,
  defaultFormError,
  defaultFiles,
};
